import onboardingSlice from './onboardingSlice'
export default onboardingSlice.reducer
